export default __webpack_public_path__ + "static/media/ES.b033e596.svg";